import React from 'react';
import ProcessBar from 'components/common/ProcessBar';
import Cookies from 'js-cookie';
import { httpStatus, httpTextStatus } from 'model/constants/variableConstant';
import { getFullStringBase64 } from 'utils/media';
import { LINK_DEV } from 'constants/index';
import { logoutServ } from 'model/services/LoyaltyAccountInfoService';
import Utils from 'utils';
let timer;
export const countTimeout = 900000;

export function convertPoint(input) {
  if (input !== null && input !== '') {
    const currency = Math.round(input);
    return currency.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
  }
  return '';
}
export function getFunctionSupport() {
  const eposFunctionSupport = Cookies.get('eposFunctionSupport');
  const functionSupport = eposFunctionSupport ? JSON.parse(eposFunctionSupport) : null;
  return functionSupport;
}

export function dateFormat(date) {
  if (date) {
    let dateConvert = new Date(date);
    let day = dateConvert.getDate();
    let month = dateConvert.getMonth() + 1;
    let year = dateConvert.getFullYear();
    if (day < 10) {
      day = '0' + day;
    }
    if (month < 10) {
      month = '0' + month;
    }
    return day + '/' + month + '/' + year;
  }
  return '';
}

export function setAccount(account) {
  Cookies.set('eposAccount', account, { expires: 10 / (60 * 24) }); // 10 phut
}

export function getAuth() {
  const eposAuth = Cookies.get('eposAuth');
  return eposAuth ? JSON.parse(eposAuth) : null;
}

export function getMemberCode() {
  /*const memberCode = Cookies.get('memberCode');
    const member = memberCode ? JSON.parse(memberCode) : null;
    return member;*/
  const memberCode = localStorage.getItem('memberCode');
  const member = memberCode ? JSON.parse(memberCode) : null;
  return member;
}

export function getPathName() {
  // return window.location.pathname;
  return window.location.pathname;
}

export function isErrorNetwork(error) {
  return error;
}

export function isNullOrEmpty(obj) {
  return typeof obj === 'undefined' || obj === null || Object.keys(obj).length === 0;
}

export function isPending(pending) {
  return pending ? <ProcessBar /> : null;
}

export function isSuccess(obj) {
  return obj && obj === httpStatus.success;
}

export function objToString(obj) {
  return typeof obj === 'undefined' || obj === null ? '' : obj.toString().trim();
}

export function setMemberCode(memberCode) {
  //Cookies.set('memberCode', memberCode)
  localStorage.setItem('memberCode', JSON.stringify(memberCode));
}

export function setTimeoutLogin() {
  if (Cookies.get('eposAuth')) {
    clearTimeoutLogin(timer);
    timer = setTimeout(() => {
      clearCookies();
      // window.location.href = `${LINK_DEV}`;
    }, countTimeout);
  }
}

export function isBlank(obj) {
  return !obj || /^\s*$/.test(obj);
}

export function removeAuth() {
  if (Cookies.get('eposAuth')) {
    Cookies.remove('eposAuth');
  }
}

export function removeTokenLoyalty() {
  if (Cookies.get('tokenLoyalty')) {
    Cookies.remove('tokenLoyalty');
  }
}

export function removeFunctionSupport() {
  if (Cookies.get('eposFunctionSupport')) {
    Cookies.remove('eposFunctionSupport');
  }
}

export function removeAccount() {
  if (Cookies.get('eposAccount')) {
    Cookies.remove('eposAccount');
  }
}

export function setAuth(auth) {
  Cookies.set('eposAuth', auth);
}

export const setListAccountUser = (listAccountUser) => {
  localStorage.setItem('listAccountUser', JSON.stringify(listAccountUser));
};

export function removeMenus() {
  if (localStorage.getItem('eposMenus')) {
    localStorage.removeItem('eposMenus');
  }
}

export const getAvatarUser = () => {
  try {
    const avatarUser = JSON.parse(localStorage.getItem('avatarUser'));
    return avatarUser ? getFullStringBase64(avatarUser) : null;
  } catch (error) {}
};

export function removeMemberCode() {
  /*if (Cookies.get('memberCode')) {
        Cookies.remove('memberCode')
    }*/
  if (localStorage.getItem('memberCode')) {
    localStorage.removeItem('memberCode');
  }
}

export function removeInsurrance() {
  if (localStorage.getItem('insurrance')) {
    localStorage.removeItem('insurrance');
  }
}

function clearTimeoutLogin(time) {
  if (time) {
    clearTimeout(time);
  }
}

export const removeAvatarUser = () => {
  if (localStorage.getItem('avatarUser')) {
    localStorage.removeItem('avatarUser');
  }
};

export const removeListAccountUser = () => {
  if (localStorage.getItem('listAccountUser')) {
    localStorage.removeItem('listAccountUser');
  }
};

export function setRewardDetail(rewardDetail) {
  Cookies.set('rewardDetail', rewardDetail);
}

export function clearCookies() {
  logoutServ()
    .then((res) => {
      removeAuth();
      removeFunctionSupport();
      removeAccount();
      removeMenus();
      removeMemberCode();
      removeInsurrance();
      clearTimeoutLogin(timer);
      removeAvatarUser();
      removeListAccountUser();
      removeTokenLoyalty();
      Utils.removeLocalStorage();
      window.location.href = LINK_DEV;
    })
    .catch((err) => {
      removeAuth();
      removeFunctionSupport();
      removeAccount();
      removeMenus();
      removeMemberCode();
      removeInsurrance();
      clearTimeoutLogin(timer);
      removeAvatarUser();
      removeListAccountUser();
      removeTokenLoyalty();
      Utils.removeLocalStorage();
      window.location.href = LINK_DEV;
    });
}

export function clearStorage() {
  removeAuth();
  removeFunctionSupport();
  removeAccount();
  removeMenus();
  removeMemberCode();
  removeInsurrance();
  clearTimeoutLogin(timer);
  removeAvatarUser();
  removeListAccountUser();
  removeTokenLoyalty();
  Utils.removeLocalStorage();
  window.location.href = LINK_DEV;
}

export function validateImageUpload(fileName) {
  let extention = false;
  const regex = /\.(gif|jpe?g|jpg|png|JPG|PNG|GIF|JPEG)$/i;
  extention = regex.test(fileName);
  return extention;
}

export function formatName(name) {
  const containNumber = /\d+/;
  if (containNumber.test(name)) {
    return true;
  } else {
    // const re =  /[!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?]/;
    const re = /[\\|,<>\/?]/;
    return re.test(name);
  }
}

export function validatePhone(phoneNumber) {
  const phone = /^\+?(?:[0-9]??).{9}[0-9]$/;
  return phone.test(phoneNumber);
}

export function validateEmail(email) {
  if (email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  } else {
    return true;
  }
}
export function validName(name) {
  if (name === 'undefined' || name === null) return true;
  var nameArr = name.trim().replace(/\s\s+/g, ' ').split(' ');
  if (nameArr.length < 2) {
    return true;
  } else {
    const re = /[\\|,<>\/?]/;
    return re.test(name);
  }
}

export function clearLocalStorage() {
  let keyToRemove = [];
  for (var key in localStorage) {
    keyToRemove.push(key);
  }
  const arr = keyToRemove.filter((item) => item !== 'timeBuild');
  for (key of arr) {
    localStorage.removeItem(key);
    clearCookies();
  }
}

export function setTokenLoyalty(token) {
  Cookies.set('tokenLoyalty', token);
}

export function getTokenLoyalty() {
  const token = Cookies.get('tokenLoyalty');
  return token ? token : null;
}

export const setLocalGiftGroupCodeFilter = (giftGroupCodeFilter) => {
  localStorage.setItem('giftGroupCodeFilter', giftGroupCodeFilter);
};

export const getLocalGiftGroupCodeFilter = () => {
  return localStorage.getItem('giftGroupCodeFilter') ?? null;
};
